import {useLocation} from 'react-router-dom';

interface GetPageHeaderTitle {
	internalPaths: Record<string, string>;
	mainPath: string;
}

export function getPageHeaderTitle({internalPaths, mainPath}: GetPageHeaderTitle) {
	const {pathname} = useLocation();
	const pathKey = Object.keys(internalPaths).find(path => pathname.includes(path));
	return pathKey ? internalPaths[pathKey] : mainPath;
}
